/** @format */
import { FilterOption } from '@toucan/client/features/search/config/types';

export function handleAccessorySelect(
    label: FilterOption['label'],
    value: FilterOption['value'],
    checked: boolean,
    onAccessorySelect: (selectedOptions: FilterOption[]) => void,
    selectedOptions: FilterOption[]
) {
    if (!checked) {
        const selectedOptionsWithoutUncheckedValue = selectedOptions.filter(
            (option) => option.value !== value
        );
        onAccessorySelect(selectedOptionsWithoutUncheckedValue);
        return;
    }

    onAccessorySelect([...selectedOptions, { label, value }]);
}

export function isAccessorySelected(
    option: FilterOption['value'],
    selectedOptions: FilterOption[]
) {
    return selectedOptions.some((selectedOption) => {
        return selectedOption.value === option;
    });
}
